/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    Button,
    Stack,
    Box,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {styleConfigChakraKeys} from '../../../constants'

const Suggestions = ({suggestions, closeAndNavigate}) => {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.search)

    if (!suggestions) {
        return null
    }
    return (
        <Stack spacing={0} data-testid="sf-suggestion">
            <Box>
                {suggestions.map((suggestion, idx) => (
                    <Box
                        width={{xl: 'fit-content'}}
                        paddingLeft="2px"
                        key={idx}
                    >
                        <Button
                            width="full"
                            onMouseDown={() =>
                                closeAndNavigate(suggestion.link)
                            }
                            marginTop={0}
                            variant="unstyled"
                            height="auto"
                        >
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: suggestion.name
                                }}
                                {...styles.suggestionText}
                            />
                        </Button>
                    </Box>
                ))}
            </Box>
        </Stack>
    )
}

Suggestions.propTypes = {
    suggestions: PropTypes.array,
    closeAndNavigate: PropTypes.func
}

export default Suggestions
